











import { Component, Vue, Prop } from "vue-property-decorator";
import { className } from "@/utilities";

@Component({ components: {} })
export default class PlantTypeNavButton extends Vue {
  @Prop() readonly name!: string;

  get typeClassName() {
    return className(this.name);
  }
}
